const d =
	'M290-223h83v-84h84v-83h-84v-84h-83v84h-84v83h84v84Zm221-154h243v-70H511v70Zm0 135h163v-70H511v70ZM149-55q-39.05 0-66.525-27.475Q55-109.95 55-149v-462q0-39.463 27.475-67.231Q109.95-706 149-706h216v-122q0-34 21.384-56 21.385-22 57.116-22H518q34 0 56 22t22 56v122h215q39.463 0 67.231 27.769Q906-650.463 906-611v462q0 39.05-27.769 66.525Q850.463-55 811-55H149Zm303-553h57v-211h-57v211Z';

export default d;
